module.exports = __webpack_public_path__ + "static/media/faqWhatMMTool.4ccd73ef.png";